import { render } from "./horizontalChart.vue?vue&type=template&id=04df3854"
import script from "./horizontalChart.vue?vue&type=script&lang=js"
export * from "./horizontalChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__